<!--  -->
<template>
  <div class="add_box">
    <div class="search_box">
      <div>
        <el-input
          v-model="objr.remark"
          style="width:200px;margin-right:10px"
          placeholder="请输入备注"
        />
        <el-select
          v-model="objr.status"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          type="primary"
          style="margin-left:10px"
          icon="el-icon-search"
          @click="sraw"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh"
          @click="awered"
        >重置</el-button>
      </div>
      <div>
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="addbit"
        >新增</el-button>
      </div>
    </div>

    <!-- <el-button type="primary" @click="awered">重置</el-button> -->
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        prop="source_account_id"
        label="来源账户id"
        align="center"
        width="230"
      >
        <template scope="scope">
          <div v-if="scope.row.source_account_id">{{ scope.row.source_account_id }}</div>
        </template>
      </el-table-column>

      <el-table-column
        prop="source_project_id"
        label="来源项目id"
        width="200"
        align="center"
      />
      <el-table-column
        prop="source_project_name"
        label="来源项目名称"
        width="200"
        align="center"
      />
      <el-table-column
        prop="target_name"
        label="目标项目名称"
        width="200"
        align="center"
      />
      <el-table-column
        prop="start_time"
        label="开始投放日期"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          第{{ scope.row.start_time }}天
        </template>
      </el-table-column>
      <el-table-column
        prop="end_time"
        label="结束投放日期"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          第{{ scope.row.end_time }}天
        </template>
      </el-table-column>
      <el-table-column
        prop="opt_status_text"
        label="广告状态"
        width="150"
        align="center"
      />
      <el-table-column
        prop="remark"
        label="状态"
        width="200"
        align="center"
      >
        <template slot-scope="scope" :loading="tableSwitchLoading">
          <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="2"
            :show-text="false"
            @change="checkRow(scope.row)"
          />
          <span style="margin-left: 8px;">
            {{ scope.row.status === 1 ? '开启' : '关闭' }}
          </span>
        </template>

      </el-table-column>
      <el-table-column
        prop="app_id"
        label="投放产品id"
        width="200"
        align="center"
      />
      <el-table-column
        prop="material_num"
        label="使用素材数量"
        width="150"
        align="center"
      />
      <el-table-column
        prop="chapter_index"
        label="章节序号"
        width="150"
        align="center"
      />
      <el-table-column
        prop="budget_mode_text"
        label="项目预算"
        width="150"
        align="center"
      />
      <el-table-column
        prop="budget"
        label="预算金额"
        width="150"
        align="center"
      />
      <el-table-column
        prop="search_bid_ratio"
        label="出价系数"
        width="150"
        align="center"
      />
      <el-table-column
        prop="status_text"
        label="广告状态"
        width="150"
        align="center"
      >
        <template scope="scope">
          <div class="status-wrapper">
            <span :class="['status-dot', getDotClass(scope.row.status)]" />
            <span>{{ scope.row.status_text }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        width="200"
        align="center"
      />
      <el-table-column
        prop="source_account_id"
        label="绑定账户"
        align="center"
        width="230"
      >
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.account_ids.join(', ')"
            placement="top"
          >
            <div class="ellipsis">
              {{ scope.row.account_ids.join(', ') }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="创建时间"
        align="center"
        width="180"
      />
      <el-table-column
        align="center"
        prop="work_status"
        label="操作"
        fixed="right"
        width="260"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="copy(scope.row)"
          >复用</el-button>
          <el-button
            type="warning"
            size="mini"
            @click="edit(scope.row)"
          >编辑</el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteItem(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      ref="paginationbox"
      :total="newtotalr"
      :page-sizes="[10]"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />
    <el-dialog
      :title="adtype !== 2 ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="40%"
    >
      <readingcreatedialog
        ref="readingcreateview"
        @updatawe="updatawe"
      />
    </el-dialog>
  </div>
</template>

<script>
import readingcreatedialog from './components/readingcreatedialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { createadconfiglist, createadconfigdel, createAdSwitch } from '@/api/report/adx'
export default {
  components: {
    readingcreatedialog,
    PaginationRight
  },
  data() {
    return {
      dialogVisible: false,
      objr: {
        page: 1,
        page_size: 10,
        remark: '',
        status: ''
      },
      adtype: null,
      newtotalr: null,
      tableData: [],
      loading: false,
      options: [
        {
          value: 1,
          label: '开启'
        },
        {
          value: 2,
          label: '关闭 '
        }
      ],
      tableSwitchLoading: false // 控制所有 switch 的 loading 状态
    }
  },
  created() {
    this.menuList()
  },
  mounted() {},
  methods: {
    async menuList() {
      // 获取列表
      this.loading = true
      const data = await createadconfiglist(this.objr)
      console.log('data', data)
      this.loading = false
      this.tableData = data.data.list
      this.newtotalr = data.data.total
    },
    sraw() {
      this.objr.page = 1
      // this.objr.pageSize = 10
      this.menuList()
    },
    awered() {
      this.objr.page = 1
      this.objr.remark = ''
      this.objr.status = ''
      this.menuList()
    },
    addbit() {
      this.dialogVisible = true
      this.adtype = 1
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.readingcreateview.send(1)
      }, 100)
    },
    edit(item) {
      this.dialogVisible = true
      this.adtype = 2
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.readingcreateview.send(2, item)
      }, 100)
    },
    copy(item) {
      this.dialogVisible = true
      this.adtype = 3
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.readingcreateview.send(3, item)
      }, 100)
    },
    // 删除
    async deleteItem(row) {
      this.$confirm('是否确定删除该条信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        await createadconfigdel({ id: row.id })
        this.menuList()
        this.$message({
          message: '删除成功',
          type: 'success'
        })
      })
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    updatawe() {
      this.dialogVisible = false
      this.menuList()
    },
    checkRow(val) {
      this.tableSwitchLoading = true
      // eslint-disable-next-line no-empty
      try {
        createAdSwitch({
          id: val.id,
          status: val.status
        }).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.$message.success('修改成功')
          }
        })
      } finally {
        setTimeout(() => {
          this.tableSwitchLoading = false
        }, 2000)
      }
      console.log(val)
    },
    getDotClass(status) {
      switch (status) {
        case 0:
          return 'dot-orange' // 橙色：处理中
        case 1:
          return 'dot-green' // 成功
        case 2:
          return 'dot-red' // 失败
        default:
          return 'dot-gray' // 未知状态
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box {
  padding: 20px;
}
.search_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.status-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #666;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
}

.dot-green {
  background-color: #52c41a;
}
.dot-orange {
  background-color: #faad14;
}
.dot-red {
  background-color: #ff4d4f;
}
.dot-gray {
  background-color: #d9d9d9;
}
</style>
